/**
 * Resolve preview URL for File, blob URL, or server path.
 * @param {File|string|null} fileOrUrl
 * @param {string} cacheKey - e.g. updatedAt or id for cache bust on server URLs
 */
export function resolvePreviewUrl(fileOrUrl, API_BASE, cacheKey = '') {
  if (!fileOrUrl) return '';
  if (typeof fileOrUrl !== 'string') {
    try {
      return URL.createObjectURL(fileOrUrl);
    } catch {
      return '';
    }
  }
  const s = fileOrUrl.trim();
  if (!s) return '';
  if (s.startsWith('blob:') || s.startsWith('data:')) return s;
  let url = s.startsWith('http') ? s : (s.startsWith('/') ? `${API_BASE}${s}` : s);
  if (cacheKey && url.includes('/uploads/')) {
    const sep = url.includes('?') ? '&' : '?';
    url = `${url}${sep}v=${encodeURIComponent(String(cacheKey))}`;
  }
  return url;
}
